module.exports = __webpack_public_path__ + "img/play.3432c888.png";